import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('customers'))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('customer?customer_id=' + data.customer_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('customer', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('customer', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('customer', { data: data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/CustomerService.js